import { CompanyDraftContent } from '@blockpulse3/graphql/hooks';

import { LegalInformationsForm } from '../../Forms/LegalInformationsForm';
import { useSPVForm } from '../../provider';

type Props = {
  /* ** Next step callback ** */
  onSubmit: (data: CompanyDraftContent) => void;
};

/**
 * LegalInformationsStep.
 * Step that renders the form for the legal informations of the SPV.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function LegalInformationsStep({ onSubmit }: Props): JSX.Element {
  const { companyDraftContent } = useSPVForm();

  const handleLegalInfosSubmit = (data: CompanyDraftContent): void => {
    onSubmit(data);
  };

  return (
    <LegalInformationsForm defaultValues={companyDraftContent} onSubmit={handleLegalInfosSubmit} />
  );
}

export type LegalInformationsStepProps = Props;
